<mat-spinner *ngIf="isLoading"></mat-spinner>

<mat-accordion multi="true" *ngIf="posts.length > 0 && !isLoading">


    <mat-card class="imageCard" *ngFor="let post of posts">
        <p> {{ post.title }}</p>


        <div class="image-container">

            <img [src]="post.imagePath" [alt]="post.title" srcset="">


        </div>
        <p>{{ post.content }}</p>
        <mat-action-row *ngIf="userIsAuthanticated && userId==post.creator">

            <button mat-button color="primary" (click)="onDownload(post.imagePath)">Download</button>
            <button mat-button color="warn" (click)="onDelete(post.id)">DELETE</button>
        </mat-action-row>
    </mat-card>

</mat-accordion>

<!-- adding paginator -->

<mat-paginator [length]="totalPosts" [pageSize]="postsPerPage" [pageSizeOptions]="pageSizeOptions" (page)="onChangedPage($event)" *ngIf="posts.length > 0"></mat-paginator>
<p class="info-text mat-body-1" *ngIf="posts.length <= 0 && !isLoading">No posts added yet!</p>